import styled from 'styled-components'
import { COLORS } from 'theme'

export const EditorContent = styled.span`
  padding: 20px 0;
  word-break: break-all;
  * {
    line-height: 188%;
    color: ${COLORS.GREY_T_50_2} !important;
  }
  p,
  ul,
  ol {
    margin-bottom: 10px;
  }
  li {
    line-height: 25px;
  }
`
